var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoPlay)?_c('div',{staticClass:"video-container"},[_c('p',{staticClass:"video-title"},[_c('span',[_vm._v(_vm._s(_vm.videoInfo.title))]),_c('i',{staticClass:"el-icon-close",on:{"click":_vm.closePlay}})]),_c('video',{attrs:{"src":_vm.videoInfo.playUrl,"controls":"","preload":"","autoplay":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }